import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as S from "./styles";
import Select from 'react-select';
import { useToken } from '../TokenContext';
import Swal from "sweetalert2";

export function CarrinhoItens({data, fetchMyCarrinho}) {

    const selectOptions = [
        { value: '110V', label: '110V' },
        { value: '220V', label: '220V' },
    ];
    const navigate = useNavigate();
    const { checkToken } = useToken();
    const [formLoading, setFormLoading] = useState(false);
    const [carrinhoData, setCarrinhoData] = useState({
        voltagem: '',
    });
 
    useEffect(() => {
        if (data?.voltagem) {
            setCarrinhoData({ voltagem: data.voltagem });
        }
    }, [data]);

    const baseUrl = process.env.REACT_APP_API_URL;
    const accessToken = localStorage.getItem('access_token');
   
    const handleSelectChange = async (name, selectedOption) => {
        const newData = {
            ...carrinhoData,
            [name]: selectedOption.value
        };
    
        setCarrinhoData(newData);
    
        try {
            const response = await fetch(`${baseUrl}/carrinho/voltagem/${data.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify(newData)
            });
    
            const result = await response.json();
    
            if (!response.ok) {
                navigate('/carrinho', {
                    state: {
                        message: { type: 'error', text: result.message },
                    },
                });
                return;
            }
    
            fetchMyCarrinho();
            navigate('/carrinho', {
                state: {
                    message: { type: 'success', text: result.message },
                },
            });

    
        } catch (error) {
            console.error(error.message);
        }
    };

    const handleRemove = (id) => {
        Swal.fire({
            title: "Tem certeza?",
            text: "Esta ação não pode ser desfeita!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#19a91b",
            confirmButtonText: "Sim, remover!",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                handleRemoveProduct(id);
            }
        });
    };

    const handleRemoveProduct = async () => {
  
        try {
            setFormLoading(true);
            
            const response = await fetch(`${baseUrl}/remover/premio/carrinho/${data.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
            });

            const result = await response.json();

            if (!response.ok) {
                setFormLoading(false);
                navigate('/carrinho', {
                    state: {
                        message: { type: 'error', text: result.message },
                    },
                });
                return;
            }
           
            setFormLoading(false);
            fetchMyCarrinho();
            checkToken();
            navigate('/carrinho', {
                state: {
                    message: { type: 'success', text: result.message },
                },
            });

        } catch (error) {
            setFormLoading(false);
            console.log(error.message);
        }
    };
    
    return (
       <S.Container>
            <div className="w-[220px] flex items-center justify-center py-1 xl:pl-6">
                <img src={`/assets/premios/full/${data.premio.imagem}`} />
            </div>
            <div className='divide divideFirst'></div>
            <div className='contentP font-secondary-xt w-[250px] flex flex-col items-center justify-center'>
                <p className="text-lg">Nome do prêmio:</p>
                <p><strong>{data.premio.nome}</strong></p>
            </div>
            <div className='divide'></div>
            <div className='contentP font-secondary-xt w-[250px] flex flex-col items-center justify-center'>
                <p className="text-lg">Solicitado em:</p>
                <p className='mb-2'>
                    <strong>{data.criado}</strong>
                </p>
                {data.premio.voltagem == 1 && (
                    <Select
                        name="voltagem"
                        options={selectOptions}
                        value={selectOptions.find(option => option.value === data.voltagem) || null}
                        onChange={selectedOption => handleSelectChange('voltagem', selectedOption)}
                        placeholder="Voltagem"
                        className="user-select voltagemSelect"
                    />
                )}
            </div>
            <div className='divide'></div>
            <div className='font-secondary-xt flex flex-col cursor-pointer w-[150px] contentP' onClick={() => handleRemove(data.id)}>
                <img className='removeImg' src='/assets/img/delete.png'/>
                <button>
                    Remover
                </button>
            </div>
            <div className='pontos font-secondary-xt py-1'>
                {`${data.premio.pontos} pontos`}
            </div>
       </S.Container>
    );
}
